import { render } from "./detalleAuditoria.vue?vue&type=template&id=b02a683a&scoped=true"
import script from "./detalleAuditoria.vue?vue&type=script&lang=js"
export * from "./detalleAuditoria.vue?vue&type=script&lang=js"

import "./detalleAuditoria.vue?vue&type=style&index=0&id=b02a683a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b02a683a"]])

export default __exports__